import SolutionsCustomerExperience from 'components/SolutionsCustomerExperience/SolutionsCustomerExperience'
import '../SolutionsPage.css'

const CustomerExperience = () => {
  return (
    <div>
      <SolutionsCustomerExperience />
    </div>
  )
}

export default CustomerExperience
